import { AgeDetails, EmotionDetails } from "~/entity/Ivideon/model/schema";

import { FaceDataBarState, LabelsType } from "./PeopleSummary";

export const formatDwellTime = (seconds: number): string => {
  if (!seconds || seconds <= 0) return "0 мин";
  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) return `${hours} ч ${minutes} мин`;
  return `${minutes} мин`;
};

export const dataContentInfoCardPeople = [
  {
    label: "Уникальные посетители",
    value: "uniqueFaces",
    title: "Уникальные посетители",
  },
  { label: "Новые посетители", value: "newFaces", title: "Новые посетители" },
  {
    label: "Повторные посетители",
    value: "returningFaces",
    title: "Повторные посетители",
  },
  { label: "Пол посетителей, м/ж", value: "gender", title: "Пол посетителей" },
  {
    label: "Ср. время пребывания",
    value: "visitTime",
    title: "Ср. время пребывания",
  },
];

export const dataContentInfoCardCar = [
  { label: "Уникальные ТС", value: "uniqueVehicles", title: "Уникальные ТС" },
  {
    label: "Новые ТС",
    value: "newVehicles",
    title: "Новые ТС",
  },
  {
    label: "Вернувшиеся ТС",
    value: "returningVehicles",
    title: "Вернувшиеся ТС",
  },
];

export interface periodIProps {
  hour: number;
  day: number;
  week: number;
  month: number;
  year: number;
}

export const period: periodIProps = {
  hour: 1,
  day: 15,
  week: 60,
  month: 61,
  year: 365,
};

export const colorListLeftMain: string[] = [
  "rgba(227, 118, 57, 1)",
  "rgba(79, 161, 255, 1)",
  "rgba(73, 90, 100, 1)",
  "rgba(0, 187, 109, 1)",
  "rgba(0, 187, 109, 1)",
  "rgba(227, 118, 57, 1)",
];
export const colorListLeftSecondary: string[] = [
  "rgba(227, 118, 57, 1)",
  "rgba(227, 118, 57, 1)",
  "rgba(73, 90, 100, 1)",
  "rgba(0, 187, 109, 1)",
  "rgba(0, 187, 109, 1)",
  "rgba(227, 118, 57, 1)",
];

export const circleColorList: string[] = [
  "rgba(0, 187, 109, 1)",
  "rgba(255, 158, 27, 1)",
  "rgba(115, 97, 255, 1)",
  "rgba(79, 161, 255, 1)",
  "rgba(73, 90, 100, 1)",
  "rgba(242, 27, 27, 1)",
];

export const colorEmotionList: string[] = [
  "rgba(255, 223, 0, 1)",
  "rgba(30, 144, 255, 1)",
  "rgba(128, 128, 128, 1)",
  "rgba(242, 27, 27, 1)",
  "rgba(255, 165, 0, 1)",
  "rgba(138, 43, 226, 1)",
  "rgba(34, 139, 34, 1)",
  "rgba(211, 211, 211, 1)",
];

export interface CircleDataItem {
  key: string;
  label: string;
  color: string;
  value: number;
}

export const ageConfig: Omit<CircleDataItem, "value">[] = [
  { key: "<18", label: "<18", color: "rgba(0, 187, 109, 1)" },
  { key: "18-24", label: "18-24", color: "rgba(255, 158, 27, 1)" },
  { key: "25-34", label: "25-34", color: "rgba(115, 97, 255, 1)" },
  { key: "35-44", label: "35-44", color: "rgba(79, 161, 255, 1)" },
  { key: "45-64", label: "45-64", color: "rgba(73, 90, 100, 1)" },
  { key: ">65", label: ">65", color: "rgba(242, 27, 27, 1)" },
];

export const emotionConfig: Omit<CircleDataItem, "value">[] = [
  { key: "happiness", label: "Счастье", color: "rgba(255, 223, 0, 1)" },
  { key: "sadness", label: "Грусть", color: "rgba(30, 144, 255, 1)" },
  { key: "neutral", label: "Нейтральность", color: "rgba(128, 128, 128, 1)" },
  { key: "anger", label: "Гнев", color: "rgba(242, 27, 27, 1)" },
  { key: "surprise", label: "Удивление", color: "rgba(255, 165, 0, 1)" },
  { key: "fear", label: "Страх", color: "rgba(138, 43, 226, 1)" },
  { key: "disgust", label: "Отвращение", color: "rgba(34, 139, 34, 1)" },
  { key: "other", label: "Другое", color: "rgba(211, 211, 211, 1)" },
];

export interface faceVariablesIProps {
  type: string;
  variant: string;
  title: string;
  data?: (number | null)[][];
  dataContentInfoCardCar?: { title: string; label: string; value: string }[];
  dataCircle?: AgeDetails | EmotionDetails;
  label: LabelsType;
  mainColor?: string;
  secondaryColor?: string;
  secondaryColor2?: string;
  circleColorList: string[];
  circleDataConfig?: CircleDataItem[];
}

const visitTime = ["<5min", "5-10min", "10-30min", "30-60min", ">60min"];

export const faceVariables = ({
  dataBar,
  labels,
}: {
  dataBar: FaceDataBarState;
  labels: LabelsType;
}): faceVariablesIProps[] => {
  const safeDataBar: FaceDataBarState = dataBar || ({} as FaceDataBarState);

  return [
    {
      type: "bar",
      variant: "uniqueFaces",
      title: "Уникальные посетители",
      data: [safeDataBar.uniqueFaces || 0],
      dataContentInfoCardCar: [
        {
          title: "Уникальные посетители",
          label: "Уникальные посетители",
          value: "Уникальные посетители",
        },
      ],
      label: labels,
      mainColor: colorListLeftMain[0],
      secondaryColor: colorListLeftMain[1],
      secondaryColor2: colorListLeftMain[1],
      circleColorList: [],
    },
    {
      type: "bar",
      variant: "newFaces",
      title: "Новые посетители",
      data: [safeDataBar.uniqueFaces || 0, safeDataBar.newFaces || 0],
      dataContentInfoCardCar: [
        {
          title: "Уникальные посетители",
          label: "Уникальные посетители",
          value: "Уникальные посетители",
        },
        {
          title: "Новые посетители",
          label: "Новые посетители",
          value: "Новые посетители",
        },
      ],
      label: labels,
      mainColor: colorListLeftMain[0],
      secondaryColor: colorListLeftMain[3],
      secondaryColor2: colorListLeftMain[3],
      circleColorList: [],
    },
    {
      type: "bar",
      variant: "returningFaces",
      title: "Повторные посетители",
      data: [safeDataBar.uniqueFaces || 0, safeDataBar.returningFaces || 0],
      dataContentInfoCardCar: [
        {
          title: "Уникальные посетители",
          label: "Уникальные посетители",
          value: "Уникальные посетители",
        },
        {
          title: "Повторные посетители",
          label: "Повторные посетители",
          value: "Повторные посетители",
        },
      ],
      label: labels,
      mainColor: colorListLeftMain[0],
      secondaryColor: "rgba(217, 220, 220, 1)",
      secondaryColor2: "rgba(73, 90, 100, 1)",
      circleColorList: [],
    },
    {
      type: "bar",
      variant: "gender",
      title: "Пол посетителей",
      data: [safeDataBar.male || 0, safeDataBar.female || 0],
      dataContentInfoCardCar: [
        { title: "мужчины", label: "мужчины", value: "мужчины" },
        { title: "женщины", label: "женщины", value: "женщины" },
      ],
      label: labels,
      mainColor: colorListLeftMain[1],
      secondaryColor: colorListLeftMain[0],
      secondaryColor2: colorListLeftMain[0],
      circleColorList: [],
    },
    {
      type: "circle",
      variant: "age",
      title: "Возраст посетителей",
      dataCircle: safeDataBar.ageDetails || {},
      circleColorList: ageConfig.map((c) => c.color),
      label: ageConfig.map((c) => c.label),
      circleDataConfig: ageConfig.map((c) => ({
        ...c,
        value:
          (safeDataBar.ageDetails?.[c.key as keyof AgeDetails] as number) || 0,
      })),
    },
    {
      type: "circle",
      variant: "emotion",
      title: "Эмоции посетителей",
      dataCircle: safeDataBar.totalEmotionDetails || {},
      circleColorList: emotionConfig.map((c) => c.color),
      label: emotionConfig.map((c) => c.label),
      circleDataConfig: emotionConfig.map((c) => ({
        ...c,
        value:
          (safeDataBar.totalEmotionDetails?.[
            c.key as keyof EmotionDetails
          ] as number) || 0,
      })),
    },
    {
      type: "bar",
      variant: "visitTime",
      title: "Среднее время пребывания",
      data: [Object.values(safeDataBar.visitTimeDetails || {})],
      dataContentInfoCardCar: visitTime.map((item) => {
        const numericValue =
          safeDataBar.visitTimeDetails?.[
            item as keyof typeof safeDataBar.visitTimeDetails
          ];
        return {
          label: "Среднее время пребывания",
          title: String(numericValue || 0),
          value: "String(numericValue || 0)",
        };
      }),
      label: visitTime,
      mainColor: colorListLeftMain[3],
      secondaryColor: colorListLeftMain[3],
      secondaryColor2: colorListLeftMain[3],
      circleColorList: [],
    },
  ];
};
